var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V24C0.5 24.8284 1.17157 25.5 2 25.5H24C24.8284 25.5 25.5 24.8284 25.5 24V2C25.5 1.17157 24.8284 0.5 24 0.5Z",
    stroke: "#666666",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10H8V20.5H5V10Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7.75C7.4665 7.75 8.25 6.9665 8.25 6C8.25 5.0335 7.4665 4.25 6.5 4.25C5.5335 4.25 4.75 5.0335 4.75 6C4.75 6.9665 5.5335 7.75 6.5 7.75Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 12.5C15.1455 12.5 14.25 13.084 14.25 14.75V20.5H11.25V10H14.25V11.105H14.2492C14.6242 10.6786 15.0859 10.3372 15.6034 10.1035C16.1209 9.86988 16.6824 9.74934 17.2502 9.75C19.4592 9.75 21.2502 11.4 21.2502 14.25V20.5H18.2502V14.75C18.2502 13.084 17.3545 12.5 16.25 12.5Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.42a2b3d7880c20f8e0af6aac697c0002.svg";
export { ForwardRef as ReactComponent };